import { AutomatedActionTypeEnum, EventTypeEnum } from '../enums';
import { DataEntityPresenterModel } from './entity-presenter.model';

export class ReactionDataEntityPresenterModel extends DataEntityPresenterModel {
  reactionActionType?: AutomatedActionTypeEnum;
  reactionEventType?: EventTypeEnum;
  reactionEntityId?: string;
}
